import { businessErrorFactory, BusinessError } from '../../../business-error';

import { RETRY_REPORT_BUSINESS_ERRORS } from './interfaces';

const RETRY_REPORT_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and report could not be generated again. Please try again. If the problem still persists, contact with support.';

const RETRY_REPORT_REPORT_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry but this report could not be found and generated again. It is possible that the report has been deleted. Please refresh the page. If the problem still persists, contact with support.';

const RETRY_REPORT_LIMIT_REACHED =
  // eslint-disable-next-line max-len
  'Sorry but you reached reports limit and you can not repair this report. If you still want to rapair it then please delete one of the existing or contact with support to increase your limit.';

export const getRetryReportBusinessError = (businessError: RETRY_REPORT_BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case RETRY_REPORT_BUSINESS_ERRORS.REPORT_NOT_FOUND: {
      return businessErrorFactory({ message: RETRY_REPORT_REPORT_NOT_FOUND, severity: 'warning' });
    }
    case RETRY_REPORT_BUSINESS_ERRORS.REPORTS_LIMIT_REACHED: {
      return businessErrorFactory({ message: RETRY_REPORT_LIMIT_REACHED, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({
        message: RETRY_REPORT_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
